// src/AppSettings.jsx
import React from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import useAppSettings from "./modules/useAppSettings";

export default function AppSettings() {
  const { settings, loading, updateSetting } = useAppSettings();

  if (loading) {
    return (
      <Box sx={{ p: 4, textAlign: "center" }}>
        <CircularProgress />
        <Typography sx={{ mt: 2 }}>Loading settings…</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", p: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        App Settings
      </Typography>

      {/* App Theme / Heading */}
      <TextField
        label="App Theme / Heading"
        fullWidth
        value={settings.theme_heading || ""}
        onChange={(e) => updateSetting("theme_heading", e.target.value)}
        sx={{ mb: 3 }}
      />

      {/* Hymn Card Variant */}
      <TextField
        select
        label="Hymn Card Display"
        fullWidth
        value={settings.card_variant || "default"}
        onChange={(e) => updateSetting("card_variant", e.target.value)}
      >
        <MenuItem value="default">Hymn Card Default</MenuItem>
        <MenuItem value="regular">Hymn Card Regular</MenuItem>
        <MenuItem value="complete">Hymn Card Complete</MenuItem>
      </TextField>
    </Box>
  );
}
